<template>
  <section class="template-manage">
    <nav class="tabs" aria-label="模板管理导航">
      <button type="button" class="tab" :class="{ active: tab === 'confirm' }" @click="switchTab('confirm')">
        确认函模板管理
      </button>
      <button type="button" class="tab" :class="{ active: tab === 'fee' }" @click="switchTab('fee')">
        缴费函模板管理
      </button>
      <button type="button" class="tab" :class="{ active: tab === 'price' }" @click="switchTab('price')">
        会费定价
      </button>
      <button type="button" class="tab" :class="{ active: tab === 'badge' }" @click="switchTab('badge')">
        胸卡模板
      </button>
    </nav>

    <div class="content">
      <ConfirmTemplateManageView v-if="tab === 'confirm'" />
      <FeeTemplateManageView v-else-if="tab === 'fee'" />
      <FeePricingManageView v-else-if="tab === 'price'" />
      <BadgeTemplateManageView v-else />
    </div>
  </section>
</template>

<script>
import ConfirmTemplateManageView from '@/views/member/ConfirmTemplateManageView.vue'
import FeeTemplateManageView from '@/views/member/FeeTemplateManageView.vue'
import FeePricingManageView from '@/views/member/FeePricingManageView.vue'
import BadgeTemplateManageView from '@/views/member/BadgeTemplateManageView.vue'

export default {
  name: 'TemplateManageView',
  components: { ConfirmTemplateManageView, FeeTemplateManageView, FeePricingManageView, BadgeTemplateManageView },
  computed: {
    tab() {
      const q = this.$route?.query?.tab
      const t = String(q || '').toLowerCase()
      if (t === 'fee') return 'fee'
      if (t === 'price') return 'price'
      if (t === 'badge') return 'badge'
      return 'confirm'
    },
  },
  methods: {
    switchTab(which) {
      const tab =
        which === 'fee' ? 'fee' : which === 'price' ? 'price' : which === 'badge' ? 'badge' : 'confirm'
      this.$router.replace({ path: '/member/templates', query: { tab } })
    },
  },
}
</script>

<style scoped>
/* 与「入会申请管理」(JoinApplyManageView) 顶部分段导航同一套样式 */
.template-manage {
  min-height: 100%;
}
.tabs {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding: 4px;
  border-radius: 12px;
  background: #eef2f7;
}
.tab {
  border: 1px solid transparent;
  background: transparent;
  color: #475467;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.tab:hover {
  background: rgba(255, 255, 255, 0.7);
  color: #26457d;
}
.tab.active {
  background: #fff;
  color: #2f6af6;
  border-color: #d0d7e2;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}
.content {
  border-radius: 12px;
  padding: 0;
}
</style>

